import React from 'react';
import ReactDOM from 'react-dom';
import { genericMemo } from '../utils/index.js';

function Portal(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/ReactDOM.createPortal(children, document.body));
}

var Portal$1 = genericMemo(Portal);

export { Portal$1 as default };
//# sourceMappingURL=Portal.js.map
